import { newIntlMessage } from '../i18n/i18nDucks';

// init bannerset name
export const initBannerSetName = newIntlMessage('properties.bannerSet-name.default').toUpperCase();
